/**
 * 抽獎算法工具
 * 實作加權隨機抽取
 */

/**
 * 根據權重隨機抽取獎項
 * @param {Array} prizes - 獎項陣列，每個獎項需包含 weight 屬性
 * @returns {Object} 抽中的獎項
 */
export const weightedRandomPick = (prizes) => {
  if (!prizes || prizes.length === 0) {
    throw new Error('獎項列表不能為空');
  }

  // 計算總權重
  const totalWeight = prizes.reduce((sum, prize) => sum + prize.weight, 0);
  
  if (totalWeight <= 0) {
    throw new Error('總權重必須大於 0');
  }

  // 生成 0 ~ totalWeight 之間的隨機數
  let random = Math.random() * totalWeight;
  
  // 根據權重區間選擇獎項
  for (const prize of prizes) {
    random -= prize.weight;
    if (random <= 0) {
      return prize;
    }
  }
  
  // 保險機制（理論上不會執行到這裡）
  return prizes[prizes.length - 1];
};

/**
 * 測試權重分布（開發用）
 * @param {Array} prizes - 獎項陣列
 * @param {Number} iterations - 測試次數
 */
export const testWeightDistribution = (prizes, iterations = 10000) => {
  const results = {};
  
  for (let i = 0; i < iterations; i++) {
    const prize = weightedRandomPick(prizes);
    results[prize.name] = (results[prize.name] || 0) + 1;
  }
  
  console.log('=== 權重分布測試 ===');
  prizes.forEach(prize => {
    const count = results[prize.name] || 0;
    const percentage = ((count / iterations) * 100).toFixed(2);
    console.log(`${prize.name}: ${percentage}% (目標: ${prize.weight}%)`);
  });
};
